import Select from "react-select";
import { useAppList } from "./hooks";
import { useComponent, useElement, useLocale } from "../../../hooks";

export const AppList = () => {
  const { t } = useLocale();
  const Button = useElement("Button");
  const Link = useElement("Link");
  const Input = useElement("Input");
  const Table = useComponent("Table");
  const TrashConfirmModal = useComponent("TrashConfirmModal");
  const {
    trackScrolling,
    checkedList,
    checkedAll,
    setisMultipleDelete,
    setshowTrashConfirm,
    activeFilter,
    setactiveFilter,
    filterItems,
    appStatus,
    searchKey,
    search,
    resetSearch,
    tableContent,
    activeShownTotal,
    deleteChecked,
    trashApp,
    trashCancel,
    showTrashConfirm,
    isMultipleDelete,
  } = useAppList();
  return (
    <div id="content-box" className="content" onScroll={trackScrolling}>
      <h1 className="title flex mb50">
        All Apps
        <Link className="btn btn-primary btn-small ml20" href="/admin/app/add">
          {t("add")}
        </Link>
        {(checkedList.length !== 0 || checkedAll) && (
          <Button
            onClick={() => {
              setisMultipleDelete(true);
              setshowTrashConfirm(true);
            }}
            className="btn btn-outline btn-small"
          >
            {t("delete")}
          </Button>
        )}
      </h1>
      <div className="filter-box">
        <div className="filters relative">
          <label className="filter-label-add">{t("status")}: </label>
          <Select
            value={activeFilter}
            defaultValue={activeFilter}
            onChange={(e, i) => {
              setactiveFilter(e);
              filterItems(e.value, i);
            }}
            options={appStatus}
          />
        </div>
        <div className="search-box">
          <Input
            name="searchKey"
            value={searchKey || ""}
            placeholder={t("placeholder.search")}
            onChange={search}
          />
          <i className="hi-close" onClick={resetSearch}></i>
        </div>
      </div>
      <Table data={tableContent} pageSize={activeShownTotal} />
      <TrashConfirmModal
        trashOkAction={() => {
          isMultipleDelete ? deleteChecked() : trashApp();
        }}
        trashCancelAction={trashCancel}
        showTrashConfirm={showTrashConfirm}
        isMultipleDelete={isMultipleDelete}
      />
    </div>
  );
};
